import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/spelling-demo/page.tsx");
